import { useEffect, useState } from "react";

import { useLogger } from "./logger";

export default function useSalesForceChat(
  accessToken?: string,
  onmouuid?: string,
) {
  const [loadSalesForceScript, setLoadSalesForceScript] = useState(false);

  const { error } = useLogger();

  useEffect(() => {
    handleAsyncSalesForceScript();
  }, [loadSalesForceScript]);

  const handleAsyncSalesForceScript = async () => {
    if (!loadSalesForceScript) return;

    try {
      const loadSalesForce = () => {
        return new Promise<void>((resolve, reject) => {
          const script = document.createElement("script");
          script.src = `${process.env.NEXT_PUBLIC_SALESFORCE_ONMO_CHAT_URL}/ESWOnmoChat1712304686784/assets/js/bootstrap.min.js`;
          script.async = true;
          script.onload = async () => {
            const jsScript = document.createElement("script");
            jsScript.src =
              process.env.NEXT_PUBLIC_STAGE == "staging"
                ? "/static/js/salesforce-staging.js"
                : "/static/js/salesforce-prod.js";
            jsScript.async = true;
            jsScript.onload = () => {
              try {
                if (accessToken && onmouuid) {
                  // NOTE: This is a global function from the salesforce script
                  // TODO: I would like to refactor it, so that we don't need to
                  // use a global function.

                  // @ts-ignore
                  // eslint-disable-next-line no-undef
                  initEmbeddedMessaging(accessToken, onmouuid);
                } else {
                  // @ts-ignore
                  // eslint-disable-next-line no-undef
                  initEmbeddedMessaging();
                }
                setLoadSalesForceScript(false);
                resolve();
              } catch (err) {
                setLoadSalesForceScript(false);
                error("Error loading Embedded Messaging: ", err);
                reject(err);
              }
            };

            jsScript.onerror = err => {
              error("Script error:", err);
              setLoadSalesForceScript(false);
              reject(err);
            };

            document.body.appendChild(jsScript);
          };
          script.onerror = err => {
            error("Script error:", err);
            setLoadSalesForceScript(false);
            reject(err);
          };
          // Append the script to the DOM
          document.body.appendChild(script);
        });
      };
      await loadSalesForce();
    } catch (err) {
      error("Error::", err);
      setLoadSalesForceScript(false);
    }
  };

  return { setLoadSalesForceScript, loadSalesForceScript };
}
